// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
// require("turbolinks").start()
require("@rails/activestorage").start()

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
require("jquery")
require("bootstrap")
require("bootstrap4-toggle")
require("admin-lte")
require('lightbox2');
require('sortablejs');
import 'lightbox2/dist/css/lightbox.min.css';
import 'packs/setting';
import 'packs/shift';
import 'packs/waitlist';
import 'packs/waitlist_search';
import 'packs/navbar';
import 'packs/medical_question';
import 'packs/line';
import 'packs/line_single_template';
import '../channels/waitlist_channel';
import lightbox from 'lightbox2'
import Swal from 'sweetalert2';
import Sortable from 'sortablejs';

window.$ = jQuery;
window.lightbox = lightbox;
window.Swal = Swal;
window.Sortable = Sortable;

import moment from 'moment'
window.moment = moment

$(function () {
  $('[data-toggle="tooltip"]').tooltip();

  // LINE公式サイトモーダル
  $('#lineOfficialWebsite .btn-confirm').on('click', () => {
    $('#lineOfficialWebsite').modal('hide');
  });
});
